/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.utils = {

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  debounce(func, wait, immediate) {
    let timeout = undefined;
    return function() {
      const context = this;
      const args = arguments;

      const later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };

      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  },


  // "k"-ify a number, e.g. 15000 -> 15k
  kify(n) {
    if (parseInt(n, 10) > 999) {
      return `${Math.round(parseInt(n, 10) / 1000.0)}k`;
    } else {
      return n;
    }
  },


  // just adds an s
  // Returns the number and the word, e.g. "0 credits"
  dumb_pluralize(n, word_singular) {
    const n_parsed = parseFloat((n+'').replace(/[^.\d]/g, ""));

    if ((n_parsed === 1) || (word_singular.slice(-1) === "s")) {
      return n + " " + word_singular;
    } else {
      return n + " " + word_singular + "s";
    }
  },


  escape_html(str) {
    return $("<div>").text(str).html();
  },


  // Turn "12345.67" into "12,345.67"
  // From: http://stackoverflow.com/a/3753507/126636
  number_with_delimiter(n, delimiter = ",", decimal_separator = ".") {
    n += "";
    const x = n.split(decimal_separator);
    let x1 = x[0];
    const x2 = x.length > 1 ? decimal_separator + x[1] : "";
    const rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + delimiter + "$2");
    }

    return x1 + x2;
  },


  is_ascii(str) {
    return /^[\x00-\x7F]*$/.test(str);
  }
};
